<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>

    {{ title }}: {{ quiz.title }}
    <nb-alert status="danger" *ngIf="errMessage.length > 0">
      <strong>Có Lỗi!</strong> {{ errMessage }}
    </nb-alert>
  </nb-card-header>
  <nb-card-body>
    <p *ngIf="description">{{ description }}</p>

    <form [formGroup]="diaForm">
      <div class="form-group">
        <label class="label">Tiêu đề</label>
        <input
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [ngClass]="{
            'form-control-danger':
              diaForm.invalid && (diaForm.dirty || diaForm.touched)
          }"
          #questionTitle
          [(ngModel)]="quiz.title"
        />
      </div>

      <div class="form-group">
        <label class="label">Nhập phân loại ( Tag)</label>
        <nb-tag-list (tagRemove)="onTagRemove($event)">
          <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
          <input type="text" nbTagInput (tagAdd)="onTagAdd($event)" fullWidth />
        </nb-tag-list>
      </div>

      <div class="form-group">
        <label class="label">
          Chọn loại câu hỏi

          <nb-select
            outline
            shape="round"
            size="small"
            status="info"
            formControlName="type"
            placeholder="Chọn loại câu hỏi"
            [(ngModel)]="quiz.type"
            (selectionChange)="onTypeChange()"
          >
            <nb-option value="radio">Trắc nghiệm</nb-option>
            <nb-option value="check">Chọn 1 hoặc nhiều</nb-option>
            <nb-option value="input">Nhập đáp án</nb-option>
            <!-- <nb-option value="document">Tự luận</nb-option> -->
          </nb-select>
        </label>
      </div>
    </form>

    <nb-accordion multi class="form-group">
      <nb-accordion-item expanded>
        <nb-accordion-item-header> Câu hỏi </nb-accordion-item-header>
        <nb-accordion-item-body>
          <ngx-editor-document
            [(ngModel)]="quiz.question"
          ></ngx-editor-document>
        </nb-accordion-item-body>
      </nb-accordion-item>

      <nb-accordion-item *ngIf="quiz.type !== 'document'" expanded>
        <nb-accordion-item-header> Đáp án </nb-accordion-item-header>
        <nb-accordion-item-body>
          <div
            *ngIf="quiz.type === 'check' || quiz.type === 'radio'"
            class="table-responsive"
          >
            <table class="table table-striped">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="col-no">#</th>
                  <th scope="col" class="col-checkbox">Đúng</th>
                  <th scope="col">Loại hiển thị</th>
                  <th scope="col">Giá trị</th>
                  <th scope="col" class="col-action"></th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of quiz.answers; let i = index">
                  <th scope="row"># {{ i + 1 }}</th>
                  <td>
                    <nb-checkbox
                      [(ngModel)]="item.isCorrect"
                      status="primary"
                    ></nb-checkbox>
                  </td>

                  <td colspan="2">
                    <div *ngIf="item.type !== 'document'">
                      <ngx-view-gallery
                        *ngIf="item.type === 'image'"
                        [imagesUrl]="[item.content]"
                      >
                      </ngx-view-gallery>

                      <ngx-view-video
                        *ngIf="item.type === 'video'"
                        [url]="item.content"
                      ></ngx-view-video>

                      <input
                        nbInput
                        fullWidth
                        placeholder="Nhập đường dẫn / giá trị"
                        class="form-control"
                        [(ngModel)]="item.content"
                      />
                    </div>

                    <div *ngIf="item.type === 'document'">
                      <ngx-editor-document
                        [(ngModel)]="item.content"
                      ></ngx-editor-document>
                    </div>
                  </td>

                  <td>
                    <button
                      nbButton
                      shape="round"
                      outline
                      size="small"
                      status="danger"
                      [disabled]="submitted"
                      [class.btn-pulse]="submitted"
                      (click)="removeAnswer(item)"
                    >
                      <nb-icon icon="trash-2-outline"></nb-icon>
                      <span>Xóa</span>
                    </button>
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <th scope="row"># -</th>
                  <td>
                    <nb-checkbox
                      [(ngModel)]="isCorrect"
                      status="primary"
                    ></nb-checkbox>
                  </td>

                  <td>
                    <nb-select
                      outline
                      shape="round"
                      size="small"
                      status="info"
                      placeholder="Chọn loại câu trả lời"
                      [(ngModel)]="type"
                      (selectionChange)="onAnswerTypeChange($event)"
                    >
                      <nb-option value="text">Abc/123</nb-option>
                      <nb-option value="image">Hình ảnh</nb-option>
                      <nb-option value="video">Video</nb-option>
                      <nb-option value="document">Văn bản</nb-option>
                    </nb-select>
                  </td>

                  <td>
                    <div *ngIf="type === 'text'">
                      <input
                        nbInput
                        fullWidth
                        placeholder="Nhập giá trị"
                        class="form-control"
                        #answerContent
                        [(ngModel)]="content"
                      />
                    </div>

                    <div *ngIf="type === 'image'">
                      <input
                        nbInput
                        fullWidth
                        placeholder="Nhập liên kết hình ảnh"
                        class="form-control"
                        [(ngModel)]="content"
                      />
                      <ngx-upload-image
                        [type]="'single'"
                        [size]="'tiny'"
                        [mode]="'imagekit'"
                        [path]="'/quiz/images'"
                        (onUploadSuccess)="uploadImage($event)"
                      ></ngx-upload-image>
                    </div>

                    <div *ngIf="type === 'video'">
                      <input
                        nbInput
                        fullWidth
                        placeholder="Nhập liên kết video"
                        class="form-control"
                        [(ngModel)]="content"
                      />
                    </div>

                    <div *ngIf="type === 'document'">
                      <ngx-editor-document
                        [(ngModel)]="content"
                      ></ngx-editor-document>
                    </div>
                  </td>

                  <td>
                    <button
                      nbButton
                      outline
                      fullWidth
                      status="info"
                      size="small"
                      [disabled]="submitted"
                      [class.btn-pulse]="submitted"
                      (click)="addAnswer(item)"
                    >
                      <nb-icon icon="plus-outline"></nb-icon>
                      Thêm
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div class="form-group" *ngIf="quiz.type === 'input'">
            <input
              type="text"
              nbInput
              fullWidth
              fieldSize="giant"
              status="info"
              shape="semi-round"
              placeholder="Nhập đáp án "
              class="form-control"
              [(ngModel)]="quiz.valueAnswer"
            />
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>
      <nb-accordion-item>
        <nb-accordion-item-header> Lời giải </nb-accordion-item-header>
        <nb-accordion-item-body>
          <ngx-editor-document [(ngModel)]="quiz.explain"></ngx-editor-document>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </nb-card-body>
  <nb-card-footer>
    <button
      class="save"
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
    >
      Lưu
    </button>
  </nb-card-footer>
</nb-card>
